import Vue from "vue";

export const TemplateMixin = Vue.extend({
  model: {
    prop: "customValue",
  },
  props: {
    customValue: {
      type: [String, Array as () => any, Object as () => any],
    },
    templates: {
      type: Array as () => string[],
      default() {
        return [];
      },
    },
  },
  computed: {
    computedCustomValue: {
      get(): any {
        return this.customValue;
        //TODO: Permettre la lecture d'un customValue qui n'est pas affecté par les modifications du set.
      },
      set(value: any) {
        ["default", ...this.templates].forEach(template => {
          const matchedTemplate = this.templatePatterns.find(templatePattern => {
            return templatePattern?.name == template;
          });
          if (matchedTemplate?.setValue) {
            value = matchedTemplate.setValue(value, this);
          }
        });
        this.$nextTick(() => {
          this.$emit("input", value);
        });
      },
    },
    computedProps: {
      get(): any {
        const props = { ...this.$props };
        ["default", ...this.templates].forEach(template => {
          const matchedTemplate = this.templatePatterns.find(templatePattern => {
            return templatePattern?.name == template;
          });
          if (matchedTemplate?.props) {
            matchedTemplate.props(props, this);
          }
        });
        return props;
      },
    },
    templatePatterns: {
      get(): any[] {
        return [];
      },
    },
  },
});
